import styled, { css } from 'styled-components';

interface WrapperProps {
  $noMaxWidth?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  width: 100%;
  max-width: ${(props) => props.theme.distances.containerMaxWidth};
  margin-inline: auto;
  //padding: 0 var(--main-gutter);

  ${({ $noMaxWidth }) =>
    $noMaxWidth &&
    css`
      max-width: none;
    `}
`;
